import type { ContentIdea } from "../../../../shared/types";
import { IdeaCard } from "./IdeaCard";

interface IdeaListProps {
  ideas: ContentIdea[];
  selectedIndex: number | null;
  onSelect: (index: number) => void;
  loading?: boolean;
}

export function IdeaList({
  ideas,
  selectedIndex,
  onSelect,
  loading = false,
}: IdeaListProps) {
  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center py-16">
        <div className="mb-4 h-8 w-8 animate-spin rounded-full border-2 border-brand-600 border-t-transparent" />
        <p className="text-sm text-slate-500">
          Generating ideas from your check-in...
        </p>
      </div>
    );
  }

  if (ideas.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-16">
        <p className="text-sm text-slate-400">
          No ideas yet. The ideation agent will generate content ideas once
          intake is complete.
        </p>
      </div>
    );
  }

  return (
    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
      {ideas.map((idea, index) => (
        <IdeaCard
          key={index}
          idea={idea}
          index={index}
          selected={selectedIndex === index}
          onSelect={onSelect}
        />
      ))}
    </div>
  );
}
